export default "/images/vendor/flag-icon-css/flags/1x1/cv.svg?1ddd34244b91f9c46e1d60ea251e248c";